// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — app-actions.classic.js, новая — app-actions.cp.js
import { isCp } from 'libs/design';
import * as classic from './app-actions.classic';
import * as cp from './app-actions.cp';

export const AppActions = isCp ? cp.AppActions : classic.AppActions;
